import salesService from '../../services/sales';
import type { CrmFile } from '../../types/sales';

/** Sends the chosen photos, one at a time. Returns those that were taken and how many failed. */
export async function uploadAll(kind: 'notes' | 'follow-ups' | 'updates', id: number, files: File[]): Promise<{ saved: CrmFile[]; failed: number }> {
  const saved: CrmFile[] = [];
  let failed = 0;
  for (const file of files) {
    try {
      const res = await salesService.attachFile(kind, id, file);
      if (res.success && res.data) saved.push(res.data);
      else failed += 1;
    } catch {
      failed += 1;
    }
  }
  return { saved, failed };
}
